import { render, staticRenderFns } from "./ProductMastercardCallout.vue?vue&type=template&id=3322e141&scoped=true"
import script from "./ProductMastercardCallout.vue?vue&type=script&lang=js"
export * from "./ProductMastercardCallout.vue?vue&type=script&lang=js"
import style0 from "./ProductMastercardCallout.vue?vue&type=style&index=0&id=3322e141&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3322e141",
  null
  
)

export default component.exports